export default "__VITE_ASSET__CUrVK4zE__"